<template>
    <form id="signup_form" ref="signupForm" method="post" @submit.prevent="submit">
        <slot></slot>

        <input :value="strUserInfoJson"
                type="hidden"
                name="userInfo"
                id="userInfo"
        >
        <input :value="loginId"
               type="hidden"
               name="loginId"
               id="loginId"
        >
        <input :value="userinfo.mkdb_id"
               type="hidden"
               name="username"
               id="mkdb_id"
        >
        <input :value="userinfo.jl_otp_id"
               type="hidden"
               name="jl_otp_id"
               id="jl_otp_id"
        >
        <div v-if="siwaErrorNoEmail" class="errorContainer">
            <p class="msg">
                <em class="errNote">Eメールアドレスを取得できませんでした。<br>
                    <a href="https://appleid.apple.com/">appleid.apple.com</a>にサインインし、「Apple IDを使用中のApp」から<br>
                    「J League ID Login」を削除して再度お試し下さい。<br>
                </em>
            </p>
        </div>
        <div v-else-if="isApple" class="jleague_loader">

        </div>

        <user-info-form v-show="isBasicInfo"
                        v-if="!isApple"
                        @next="next"
                        @set-password="setPassword"
                        :flp-token="flpToken"
                        :step="step"
                        :userinfo="userinfo"
                        :display-pattern="displayPattern"
                        :is-display-agreement-check="isDisplayAgreementCheck"
                        :is-email-field="isEmailField"
                        :is-xhr="isXhr"
                        :is-duplicate-jleague-id="isDuplicateJleagueId"
                        :editable-jleague-id="editableJleagueId"
                        :is-email-token="isEmailToken"
                        form-name="signup"
        >
        </user-info-form>

        <favorite-club v-if="isFavoriteClub"
                       @next="next"
                       @back="back"
                       @watch="watchCheckReceiveMail"
                       :step="step"
                       :userinfo="userinfo"
                       :is-xhr="isXhr"
                       :check-receive-mail="checkReceiveMail"
        ></favorite-club>

        <favorite-player v-if="isFavoritePlayer"
                        @next="next"
                        @back="back"
                        :step="step"
                        :userinfo="userinfo"
                        :is-xhr="isXhr"
        ></favorite-player>

        <user-info-confirm v-if="isConfirm"
                           @back="back"
                           :step="step"
                           :userinfo="userinfo"
                           :display-pattern="displayPattern"
                           :is-email-field="isEmailField"
                           :is-xhr="isXhr"
                           :is-recaptcha-invalid="isRecaptchaInvalid"
                           :is-apple="isApple"
                           form-name="signup"
                           ref="confirm"
        >
            <template slot="recaptchaUserInfo">
                <img @load="renderRecaptcha();" @error="renderRecaptcha();" src="data:image/gif;base64,R0lGODdhAQABAPAAAAAAAAAAACwAAAAAAQABAAACAkQBADs=" width="0" height="0" alt="" />
                <div v-if="recaptchaSitekey" style="display: flex; justify-content: center;">
                    <div id="recaptcha-signup" class="g-recaptcha" :data-sitekey="recaptchaSitekey"></div>
                </div>
            </template>
        </user-info-confirm>
    </form>
</template>

<script>
import { JleagueApiClient } from '../../libs/client'
import { mixinJleague, mixinUserInfoProperties, UserInfoProperties, EnumSignupStep, EnumContactCode, EnumClientDisplayPattern } from '../mixin/utility'
import UserInfoForm from './UserInfo/UserInfoForm'
import UserInfoConfirm from './UserInfo/UserInfoConfirm'
import FavoriteClubForSignup from './FavoriteClubForSignup'
import FavoritePlayerForSignup from './FavoritePlayerForSignup'

export default {
    name: 'SignupForm',
    components: {
        'user-info-form': UserInfoForm,
        'favorite-club': FavoriteClubForSignup,
        'favorite-player': FavoritePlayerForSignup,
        'user-info-confirm': UserInfoConfirm,
    },
    mixins: [mixinJleague, mixinUserInfoProperties],
    data() {
        return {
            password: '',    // FLPサインアップで使用
            checkReceiveMail: true,
            userinfo: {
                // FLP
                // email: '',
                // email_verified: true,

                // 新規登録のみ必要なプロパティの初期値を予め設定しておく
                mkdb_id: '',
                jl_otp_id: '',
                mail_address: '',
                mail_address_confirmed_flg: '1'
            },
            step: EnumSignupStep.BasicInfo,
            isXhr: false,
            strUserInfoJson: '',
            loginIdData: '',
            isDuplicateJleagueId: false, // JリーグIDが重複する
            editableJleagueId: false, // 一度JリーグIDが重複した（「戻る」で戻った時に編集できるように）
            siwaErrorNoEmail: false, // SIWA で Email を取得できないケース
            siwaErrorConflict: false, // SIWA で Email（JリーグID） が重複しているケース,
        }
    },
    props: {
        dataEmailToken: {
            type: String,
            default: '',
        },
        dataProviderId: {
            type: String,
            default: '',
        },
        dataUserInfoJson: {
            type: String,
            default: '',
        },
        flpToken: {
            type: String,
            default: '',
        },
        flpClubCode: {
            type: String,
            default: '',
        },
        flpClientId: {
            type: String,
            default: null,
        },
        flpJwtPayload: {
            type: Object,
            default() {
                return {}
            },
        },
        displayPattern: {
            type: String,
            required: true,
        },
        isDisplayAgreementCheck: {
            type: Boolean,
            required: true,
        },
        recaptchaSitekey: {
            type: String,
            required: false,
            default: null,
        }
    },
    computed: {
        /**
         * thymeleaf 変数で渡された `${signupForm?.userInfo}` を解析する
         */
        userInfoJson: function(){
            if (this.dataUserInfoJson === '') return null;

            let _result = {};
            try {
                const obj = JSON.parse(this.dataUserInfoJson);
                if (obj) {
                    const permit = this.permitProperties;

                    Object.keys(obj).forEach(function(key){
                        if (permit.indexOf(key) === -1) return;
                        _result[key] = obj[key];
                    });
                }
            } catch (e) {
                // JSON にパース出来ないとき
                // TODO: エラーを表示する
            }

            return _result;
        },
        /**
         * 新規登録時に必要な userinfo のプロパティを返す
         */
        permitProperties: function(){
            const properties = Object.keys(UserInfoProperties).map(function(key){
                return key;
            });

            return properties.concat(["mkdb_id", "jl_otp_id", "mail_address", "mail_address_confirmed_flg", "club_cd", "contact_cd", "email", "email_verified"]);
        },
        isBasicInfo: function(){
            return this.step === EnumSignupStep.BasicInfo;
        },
        isFavoriteClub: function(){
            return this.step === EnumSignupStep.FavoriteClub;
        },
        isFavoritePlayer: function(){
            return this.step === EnumSignupStep.FavoritePlayer;
        },
        isConfirm: function() {
            return this.step === EnumSignupStep.Confirm;
        },
        emailAddress: function(){
            let _email = '';
            if (this.isEmailToken) {
                // dataEmailToken から取得する場合
                const jwts = this.dataEmailToken.split('.');
                if (jwts.length > 0) _email = JSON.parse(atob(jwts[1]))['email'];
            } else if (this.userInfoJson) {
                // SNS認証など
                if (this.userInfoJson
                    && this.userInfoJson.email
                    && this.userInfoJson.email.length !== 0) {
                    _email = this.userInfoJson.email;
                }
            }

            // 確認メールフローを使わないソーシャル連携したケースがあるので `toLowerCase()` する。
            return _email.toLowerCase();
        },
        isApple: function () {
            return this.dataProviderId === "apple" && !this.siwaErrorConflict
        },
        isEmailToken: function(){
            return this.dataEmailToken !== '';
        },
        isEmailField: function(){
            // emailアドレスが空、SNS連携、FLPサインアップの場合は、メールアドレスフィールドを表示する
            return (this.emailAddress === '' || !this.isEmailToken || this.isFlpSignup);
        },
        isMKDB: function(){
            return (this.userinfo.mkdb_id !== '' && this.userinfo.jl_otp_id !== '');
        },
        loginId: function(){
            let _loginId = '';

            // メールアドレスあり
            if (this.emailAddress !== '') {
                _loginId = this.emailAddress;
            }
            if (this.emailAddress === '' && !!this.userinfo.email) {
                _loginId = this.userinfo.email;
            }
            if (this.isFlpSignup && this.flpJwtPayload) {
                _loginId = this.flpJwtPayload.email;
            }
            if (this.loginIdData !== '') {
                _loginId = this.loginIdData;
            }

            return _loginId;
        },
        isFlpSignup: function(){
            return !!this.flpToken;
        },
        homeClubCode: function (){
            const rp = this.jleagueClient;
            if (Object.keys(rp).length !== 0 && rp.hasOwnProperty('home_club_cd')){
                return rp.home_club_cd;
            }
            return null;
        }
    },
    created: function(){
        this.isFlpSignup? this.setUserInfoForFlp(): this.setUserInfo();
        if (this.isApple) {
            this.signupWithApple();
        }
    },
    mounted: function(){
    },
    methods: {
        /**
         * メールサインアップ用の userinfo プロパティーの初期値をセットする
         */
        setUserInfo(){
            if (typeof setSocialUserinfo !== 'undefined') {
                const socialUserinfo = setSocialUserinfo();
                if (this.displayPattern === EnumClientDisplayPattern.Minimum ||
                    this.displayPattern === EnumClientDisplayPattern.Normal) {
                  // 氏名
                  delete socialUserinfo.member_last_nm;
                  delete socialUserinfo.member_first_nm;
                  // 氏名カナ
                  delete socialUserinfo.member_last_nm_kana;
                  delete socialUserinfo.member_first_nm_kana;
                  // 郵便番号
                  delete socialUserinfo.post_cd1;
                  delete socialUserinfo.post_cd2;
                  // 市区町村
                  delete socialUserinfo.address_city;
                  // 町域番地
                  delete socialUserinfo.address_street;
                  // 建物番地
                  delete socialUserinfo.address_building;
                  // 電話番号建物番地
                  delete socialUserinfo.tel_no_fixed;
                }
               this.userinfo = Object.assign(this.userinfo, socialUserinfo);
            }
            // 前回入力したフォームデータを再セットする
            this.userinfo = Object.assign(this.userinfo, this.userInfoJson);

            // userinfo プロパティーの初期値をセットする
            let userinfo = this.assignDeficientProperties(this.userinfo);
            // emailアドレスがある場合でかつ、SNS連携じゃない（email tokenを持つ）場合は、MKDB_IDを取得する
            if (this.emailAddress !== '' && this.isEmailToken) {
                // userinfo.mkdb_id, userinfo.jl_otp_id はAPI経由で取得する
                this.fetchMKDB();
            }
            // emailアドレスがある場合でかつ、userinfoにjleague_idが存在しない場合のみjleague_idをemailアドレスにする
            if (this.emailAddress !== '' && this.userinfo.jleague_id === '') {
                userinfo.jleague_id = this.emailAddress;    // 新規登録時の jleague_id はメールアドレス
                userinfo.mail_address = this.emailAddress;
            }

            Object.assign(userinfo, {
                club_cd: null,
                contact_cd: null
            });

            // clientが付与されていて、clientにhome_club_cdがある時デフォルトでお気に入りクラブに追加する
            const client = this.jleagueClient;
            if (Object.keys(client).length !== 0 && client.hasOwnProperty('home_club_cd') && client.home_club_cd !== null) {
                userinfo.club_cd = client.home_club_cd;
            }

            // SNSのとき
            if (!this.isEmailToken) {
                Object.assign(userinfo, {
                    email_verified: true
                });
            }

            this.userinfo = userinfo;
        },
        /**
         * FLPサインアップ用の userinfo プロパティーの初期値をセットする
         */
        setUserInfoForFlp(){
            let userinfo = this.assignDeficientProperties(this.userinfo);
            if (this.flpJwtPayload) {
                userinfo = Object.assign(userinfo, this.flpJwtPayload);
            }
            userinfo.club_cd = null;

            if (this.flpClientId) {
                // clientが付与されていて、clientにhome_club_cdがある時デフォルトでお気に入りクラブに追加する
                const client = jleagueClientList.getClient(this.flpClientId);
                if (Object.keys(client).length !== 0 && client.hasOwnProperty('home_club_cd') && client.home_club_cd !== null) {
                    // FLPのクラブは後続で追加しているため同じ場合は追加しない
                    if (this.flpClubCode !== client.home_club_cd) {
                        userinfo.club_cd = client.home_club_cd;
                    }
                }
            }

            if (this.flpJwtPayload) {
                // トークン情報から値をセットする
                const email = this.flpJwtPayload.email;
                userinfo.email = email;
                userinfo.jleague_id = email;
                if (userinfo.club_cd != null){
                  userinfo.club_cd += (',' + this.flpClubCode);
                } else {
                  userinfo.club_cd = this.flpClubCode;
                }
            } else {
                location.href = 'https://login2.jleague.jp/login';
            }

            Object.assign(userinfo, {
                contact_cd: null
            });
            this.userinfo = userinfo;
        },
        signupWithApple:async function () {
            if (this.emailAddress !== '') {
                await this.fetchMKDB();
                if (this.userinfo.mkdb_id && this.userinfo.jl_otp_id) {
                    this.generatePostData();
                    await (this.step = EnumSignupStep.Confirm);
                    this.$refs.confirm.autoSignup();
                }
            } else {
                this.siwaErrorNoEmail = true;
            }
        },
        /**
         * FavoriteClubForSignupコンポーネントから値を受け取る
         */
        watchCheckReceiveMail: function(value){
            this.checkReceiveMail = value;
        },
        /**
         * UserInfoFormからコンポーネントから値を受け取る
         */
        setPassword: function(value){
            this.password = value;
        },
        /**
         * 「戻る」ボタンを押下したとき
         */
        back: function(step){
            switch (step) {
                case EnumSignupStep.FavoriteClub:
                    this.step = EnumSignupStep.BasicInfo;
                    break;
                case EnumSignupStep.FavoritePlayer:
                    this.step = EnumSignupStep.FavoriteClub;
                    break;
                case EnumSignupStep.Confirm:
                    this.step = EnumSignupStep.FavoritePlayer;
                    break;
                default:
                    this.step = EnumSignupStep.BasicInfo;
                    break;
            }
        },
        /**
         * 「次へ」ボタンを押下したとき
         */
        next: async function(step, userinfo){
            if (this.isXhr) return;
            switch (step) {
                case EnumSignupStep.BasicInfo:
                    if (this.userinfo.email && this.userinfo.mail_address){
                        // メールアドレスを小文字に変換する
                        this.userinfo.email = this.userinfo.email.toLowerCase();
                        this.userinfo.mail_address = this.userinfo.email.toLowerCase();
                    }
                    // MKDB が発行されていないとき MKDB IDを取得する
                    if ((!this.isMKDB && !(!this.userinfo.email)) || this.isDuplicateJleagueId) {
                        if (this.isFlpSignup) {
                            await this.fetchMKDBForFlp();
                        } else {
                            await this.fetchMKDB();
                        }
                        if (this.isDuplicateJleagueId) {
                            // エラーが出たことが分かりにくいので、トップまで戻る
                            window.scrollTo(0, 0);
                            break;
                        }
                    }

                    this.step = EnumSignupStep.FavoriteClub;
                    break;
                case EnumSignupStep.FavoriteClub:
                    let client_id = "jleague-auth";
                    if (typeof jleagueClient !== 'undefined') {
                        if (typeof jleagueClient.client_id !== 'undefined' && jleagueClient.client_id !== '') {
                            client_id = jleagueClient.client_id;
                        }
                    }
                    this.userinfo.favorite_opportunity = client_id;
                    if (this.isFlpSignup) {
                        // FLP お知らせメール用のコンタクトコードをセットする
                        this.setContactCode();
                        this.step = EnumSignupStep.FavoritePlayer;
                    } else {
                        this.step = EnumSignupStep.FavoritePlayer;;
                    }
                    break;
                case EnumSignupStep.FavoritePlayer:
                    this.step = EnumSignupStep.Confirm;
                    // 通常 確認画面に遷移後、POSTするデータを整形する
                    this.generatePostData()
                    break;
                default:
                    this.step = EnumSignupStep.BasicInfo;
                    break;
            }
        },
        setContactCode: function(){
            const self = this;

            // 初期化する
            let _contacts = [];

            // お気に入りクラブと、Ｊリーグのメールを受け取るをONにしたとき
            let codes = [];
            if (this.checkReceiveMail) {
                if (this.userinfo.club_cd){
                    codes = this.userinfo.club_cd.split(',').sort();
                }
                codes.push('JL');
                const _filer_codes = codes.filter(code => {
                    return (code !== 'G2' && code !== 'C2');
                });
                if (this.isApple && this.homeClubCode) {
                    codes.push(this.homeClubCode);
                }
                _contacts = _filer_codes.map(function(code){
                    const contactCode = (code === 'JL')?
                        [
                            EnumContactCode.StoreNoticeCode,
                            EnumContactCode.NoticeCode
                        ]:
                        [
                            EnumContactCode.NoticeCode
                        ];

                    return self.buildContactCode(code, contactCode);
                });
            }

            switch (_contacts.length) {
                case 0:
                    // 0件のときは null で登録する
                    this.userinfo.contact_cd = null;
                    break;
                case 1:
                    // 1件のときは配列ではなく文字列で登録する
                    this.userinfo.contact_cd = _contacts.toString();
                    break;
                default:
                    // 配列で登録する
                    this.userinfo.contact_cd = _contacts;
                    break;
            }
        },
        setClubCode: function(){
            if (this.userinfo.club_cd){
                const clubs = this.userinfo.club_cd;
                this.userinfo.club_cd = clubs.toString();
            }else{
                this.userinfo.club_cd = null;
            }
            if (this.isApple && this.homeClubCode) {
                this.userinfo.club_cd = this.homeClubCode;
            }
        },
        /**
         * 通常サインアップ用にMKDB IDを取得する
         */
        fetchMKDB: async function(){

            const self = this;
            const _data = {
                email:  this.emailAddress
            };
            // SNS連携の場合は、emailの値を手入力したものに変更する
            if (!this.isEmailToken && this.userinfo.email) {
                _data.email = this.userinfo.email;
                this.loginIdData = _data.email;
            }
            if (_data.email === '' && this.userinfo.email) {
                _data.email = this.userinfo.email;
            }
            if (_data.email && !this.loginId) {
                this.loginIdData = _data.email;
            }
            // email token があるときトークン情報を追加する
            if (this.isEmailToken) _data.email_token = this.dataEmailToken;

            if (this.isDuplicateJleagueId) {
                this.isDuplicateJleagueId = false;
            }
            if (this.userinfo.jleague_id) {
                _data.jleague_id = this.userinfo.jleague_id;
                this.loginIdData = this.userinfo.jleague_id;
            }

            const rp = this.jleagueClient;
            if (Object.keys(rp).length !== 0 && rp.hasOwnProperty('client_id')){
                _data.client_id = rp.client_id;
            } else {
                const query = getParameter(location.href);
                if ("provider_id" in query) {
                    _data.client_id = query["provider_id"];
                } else if (localStorage.getItem('provider_id_for_login')) {
                    _data.client_id = localStorage.getItem('provider_id_for_login');
                } else if (localStorage.getItem('provider_id_from_signup')) {
                    _data.client_id = localStorage.getItem('provider_id_from_signup');
                }
            }

            this.isXhr = true;
            const client = new JleagueApiClient();
            const errorURL = 'https://login2.jleague.jp/error?path=signup';

            await client.postMKDB(_data)
                .then(function(response){
                    const result = response.data;
                    if (!result.mkdb_id || !result.jl_otp_id) {
                        location.href = mixinJleague.methods.addUrlParams(errorURL, {
                            error_code: '02'
                        });
                    }

                    self.userinfo.mkdb_id = result.mkdb_id;
                    self.userinfo.jl_otp_id = result.jl_otp_id;
                })
                .catch(function(error){
                    const response = error.response;
                    if (response.status === 409) {
                        self.isDuplicateJleagueId = true;
                        self.editableJleagueId = true;
                        if (self.isApple) {
                            self.siwaErrorConflict = true;
                        }
                    }
                    else if (response.status !== 500) {
                        location.href = mixinJleague.methods.addUrlParams(errorURL, {
                            error_code: '02' + response.status
                        });
                    } else {
                        location.href = mixinJleague.methods.addUrlParams(errorURL, {
                            error_code: '02'
                        });
                    }
                })
                .finally(function(){
                    self.isXhr = false;
                });
        },
        /**
         * FLPサインアップ用にMKDB IDを取得する
         */
        fetchMKDBForFlp: async function(){
            const self = this;
            const _data = {
                email:  this.userinfo.email
            };
            // token があるときトークン情報を追加する
            if (!!this.flpToken) _data.flp_token = this.flpToken;

            // client_id があるときトークン情報を追加する
            if (!!this.flpClientId) _data.client_id = this.flpClientId;

            if (this.isDuplicateJleagueId) {
                this.isDuplicateJleagueId = false;
            }
            if (this.userinfo.jleague_id) {
                _data.jleague_id = this.userinfo.jleague_id;
                this.loginIdData = this.userinfo.jleague_id;
            }
            this.isXhr = true;
            const client = new JleagueApiClient();
            const errorURL = 'https://login2.jleague.jp/error?path=signup';
            await client.postMKDB(_data)
                .then(function(response){
                    const result = response.data;
                    if (!result.mkdb_id || !result.jl_otp_id) {
                        location.href = mixinJleague.methods.addUrlParams(errorURL, {
                            error_code: '02500'
                        });
                    }

                    self.userinfo.mkdb_id = result.mkdb_id;
                    self.userinfo.jl_otp_id = result.jl_otp_id;
                })
                .catch(function(error){
                    const response = error.response;
                    if (response.status === 409) {
                        self.isDuplicateJleagueId = true;
                        self.editableJleagueId = true;
                    } else if (response.status !== 500) {
                        location.href = mixinJleague.methods.addUrlParams(errorURL, {
                            error_code: '02' + response.status
                        });
                    } else {
                        location.href = mixinJleague.methods.addUrlParams(errorURL, {
                            error_code: '02'
                        });
                    }
                })
                .finally(function(){
                    self.isXhr = false;
                });
        },
        postExternalSignup: function(data){
            const self = this;

            this.isXhr = true;
            const client = new JleagueApiClient();
            client.postExternalSignup(data).then(function(response){
                location.href = response.data.redirect_uri;
            }).catch(function(error){
                const response = error.response;
                switch (response.status) {
                    case 400:
                    case 401:
                    case 403:
                    case 409:
                        self.errorMessage = '入力内容に誤りがあります。(' + response.data.message + ')';
                        break;
                    case 500:
                        self.errorMessage = '予期しないエラーが発生しました。システム管理者にお問い合わせください。(' + response.data.message + ')';
                        break;
                    default:
                        self.errorMessage = '予期しないエラーが発生しました。システム管理者にお問い合わせください。(' + error + ')';
                        break;
                }
                window.scrollTo(0, 0);
            }).finally(function(){
                self.isXhr = false;
                self.step = EnumSignupStep.BasicInfo;
            });
        },
        /**
         * 確認画面に遷移したとき
         * POSTするデータをJSON形式に変換する
         */
        generatePostData: function(){
            const self = this;
            // お知らせメール用のコンタクトコードをセットする
            this.setContactCode();
            // クラブコードを文字列にしてセットする
            this.setClubCode();
            // 空文字列のときは null に変換する
            const userinfo = Object.assign({}, this.userinfo);
            Object.keys(userinfo).forEach(function(key){
                userinfo[key] = self.emptyStringToNull(userinfo[key]);
            });
            this.strUserInfoJson = JSON.stringify(userinfo);
        },
        /**
         * 「登録」ボタンを押下したとき
         * POSTするデータをFLPサインアップ用に変換する
         */
        generatePostDataForFlp: function(){
            const self = this;
            const data = {
                token: this.flpToken,
                club_cd: this.flpJwtPayload.club_cd.toString(),
                user_info: {},
                mkdb_id: this.userinfo.mkdb_id,
                jl_otp_id: this.userinfo.jl_otp_id,
                password: this.password
            };

            return new Promise(function(resolve){
                // 空文字列のときは null に変換する
                const userinfo = Object.assign({}, self.userinfo);
                Object.keys(self.userinfo).forEach(function(key){
                    userinfo[key] = self.emptyStringToNull(userinfo[key]);
                });
                data.user_info = userinfo;

                resolve(data);
            });
        },
        /**
         * 「登録」ボタンを押下したとき
         */
        submit: async function(){
            if (this.isFlpSignup) {
                // POSTする前にデータを整形する
                const data = await this.generatePostDataForFlp();
                this.postExternalSignup(data);
            } else {
                const form = this.$refs.signupForm;
                const formData = new FormData(this.$refs.signupForm);
                form.submit();
            }
        },
        renderRecaptcha(){
            if (this.recaptchaSitekey) {
                grecaptcha.render('recaptcha-signup', {
                    'sitekey' : this.recaptchaSitekey,
                });
            }
        },
    },
}
</script>
